/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupPolicyPlan } from '../models/BackupPolicyPlan';
import { BackupPolicyResourceSelector } from '../models/BackupPolicyResourceSelector';
import { ScheduleMode } from '../models/ScheduleMode';

export class BackupPolicy {
  /**
  * Backup policy ID.
  */
  'id': string;
  /**
  * Backup policy display name.
  */
  'name': string;
  /**
  * Whether the backup policy is enabled.
  */
  'enabled': boolean;
  'resourceSelector': BackupPolicyResourceSelector;
  'backupPlan': BackupPolicyPlan;
  /**
  * Whether the security scan is enabled
  */
  'isSecurityScanEnabled'?: boolean;
  /**
  * The number of resources attached to the policy
  */
  'attachedResources'?: number;
  'scheduleMode'?: ScheduleMode;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "enabled",
      "baseName": "enabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "resourceSelector",
      "baseName": "resourceSelector",
      "type": "BackupPolicyResourceSelector",
      "format": ""
    },
    {
      "name": "backupPlan",
      "baseName": "backupPlan",
      "type": "BackupPolicyPlan",
      "format": ""
    },
    {
      "name": "isSecurityScanEnabled",
      "baseName": "isSecurityScanEnabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "attachedResources",
      "baseName": "attachedResources",
      "type": "number",
      "format": ""
    },
    {
      "name": "scheduleMode",
      "baseName": "scheduleMode",
      "type": "ScheduleMode",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackupPolicy.attributeTypeMap;
  }

  public constructor() {
  }
}



